import {FC, SVGProps} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from 'app/router/routes';
import {REGISTRATION_EDIT_PARAM} from 'features/registration';
import type {CompleteRegistrationEdit} from '../../model';
import styles from '../IdentityVerificationRejectedBanner/IdentityVerificationRejectedBanner.module.css';

const WarningTriangleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
		<path
			d="M32 8L58 54H6L32 8Z"
			stroke="currentColor"
			strokeWidth="2.4"
			strokeLinejoin="round"
		/>
		<path d="M32 26V38" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
		<circle cx="32" cy="44.5" r="1.75" fill="currentColor" />
	</svg>
);

type CompleteRegistrationBannerProps = {
	edit: CompleteRegistrationEdit;
};

export const CompleteRegistrationBanner: FC<CompleteRegistrationBannerProps> = ({edit}) => {
	const navigate = useNavigate();

	const handleCompleteRegistration = () => {
		navigate(`${ROUTES.registration}?${REGISTRATION_EDIT_PARAM}=${edit}`);
	};

	return (
		<section className={styles.banner} aria-live="polite">
			<div className={styles.top}>
				<div className={styles.text}>
					<h2 className={styles.title}>Не хватает данных</h2>
					<p className={styles.subtitle}>
						Чтобы открыть доступ ко всем возможностям приложения, нужно завершить регистрацию
					</p>
				</div>
				<span className={styles.iconWrap}>
					<WarningTriangleIcon className={styles.icon} />
				</span>
			</div>
			<button type="button" className={`${styles.button} ${styles.buttonFit}`} onClick={handleCompleteRegistration}>
				Завершить регистрацию
			</button>
		</section>
	);
};
